module.exports = __webpack_public_path__ + "static/media/banner-bg.aa504679.png";